// @flow
import type { TabItem } from "./index";

/**
 * TabItems relevant for displaying soccer markets
 *
 * @ignore
 */

const SoccerTabItems: [TabItem] = [
  {
    index: 0,
    title: "popular",
    filteringType: "match",
    displayByCategoryOrder: true,
    categories: [
      "match result",
      "double chance",
      "both teams to score",
      "sportcast goalscorer anytime",
      "sportcast player carded anytime",
      "total goals over/under",
      "corners over/under both halves",
      "corners matchbet both halves",
      "corners over/under both halves home",
      "corners over/under both halves away",
      "booking points matchbet",
      "booking points over/under",
    ],
  },
  {
    index: 1,
    title: "goals",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["goals", "goal", "score", "result", "winning", "handicap"],
  },
  {
    index: 2,
    title: "players",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["goalscorer", "player"],
  },
  {
    index: 3,
    title: "cards",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["cards", "booking", "bookings", "carded", "booked"],
  },
  {
    index: 4,
    title: "corners",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: ["corners"],
  },
  {
    index: 5,
    title: "other",
    filteringType: "include",
    displayByCategoryOrder: false,
    categories: [
      "happen",
      "incident",
      "chance",
      "method",
      "win both halves inc draw",
    ],
  },
];

export { SoccerTabItems };



// WEBPACK FOOTER //
// ./src/model/soccer.js